import { useSelector } from 'react-redux';
import { gql, useMutation } from '@apollo/client';

const useCancelSchedule = () => {
  const { userId } = useSelector(mapStateToProps);

  const [__cancelSchedule] = useMutation(MUTATION, {
    refetchQueries: [
      'scheduledDeployment',
      'getPendingDeployment'
    ]
  });
  const cancelSchedule = (versionId, scheduleId) => __cancelSchedule({
    variables: { versionId, scheduleId, userId }
  });

  return {
    cancelSchedule
  };
};

const MUTATION = gql`
mutation cancelSchedule($versionId: String!, $scheduleId: String!, $userId: String!) {
  cancelSchedule(versionId: $versionId, scheduleId: $scheduleId, userId: $userId) {
    _id
    deployAt
    version
    bucketName
    state
  }
}
`;

/* =============================================================================
=    Redux
============================================================================= */
const mapStateToProps = state => ({
  userId: state.app.user && state.app.user._id
});

export default useCancelSchedule;
